export enum ShortcutAction {
  AnswerCall = 'answer_call',
  HangUp = 'hang_up',
  ToggleMute = 'toggle_mute',
  ToggleHold = 'toggle_hold',
  ParkCall = 'park_call',
  ToggleRecording = 'toggle_recording',
  MergeCalls = 'merge_calls',
  OpenDialpad = 'open_dialpad',
  ToggleDnd = 'toggle_dnd',
  NewMessage = 'new_message',
  SwitchToCalls = 'switch_to_calls',
  SwitchToMessages = 'switch_to_messages',
  SwitchToVoicemail = 'switch_to_voicemail',
  SwitchToContacts = 'switch_to_contacts',
  JumpToActiveCall = 'jump_to_active_call',
  AttendedTransfer = 'attended_transfer',
  ReplyToLastConversation = 'reply_to_last_conversation',
  MarkConversationRead = 'mark_conversation_read',
  CallSelectedContact = 'call_selected_contact',
  VoicemailPlayPause = 'voicemail_play_pause',
  VoicemailSkipForward = 'voicemail_skip_forward',
  VoicemailSkipBack = 'voicemail_skip_back',
  VoicemailDelete = 'voicemail_delete',
  VoicemailCallBack = 'voicemail_call_back',
  FocusSearch = 'focus_search',
}

export type ShortcutBindingMap = Partial<Record<ShortcutAction, string>>;

/**
 * Only actions with a working dispatch handler get a default binding.
 * Modifier prefix follows CUC-3802's browser-conflict-avoidance recommendation for the web client.
 */
export const DEFAULT_SHORTCUT_BINDINGS: ShortcutBindingMap = {
  [ShortcutAction.AnswerCall]: 'Shift+Alt+A',
  [ShortcutAction.HangUp]: 'Shift+Alt+Q',
  [ShortcutAction.ToggleMute]: 'Shift+Alt+M',
  [ShortcutAction.ToggleHold]: 'Shift+Alt+H',
  [ShortcutAction.ParkCall]: 'Shift+Alt+P',
  [ShortcutAction.ToggleRecording]: 'Shift+Alt+R',
  [ShortcutAction.MergeCalls]: 'Shift+Alt+G',
  [ShortcutAction.OpenDialpad]: 'Shift+Alt+K',
  [ShortcutAction.ToggleDnd]: 'Shift+Alt+D',
  [ShortcutAction.NewMessage]: 'Shift+Alt+N',
  [ShortcutAction.SwitchToCalls]: 'Shift+Alt+1',
  [ShortcutAction.SwitchToMessages]: 'Shift+Alt+2',
  [ShortcutAction.SwitchToVoicemail]: 'Shift+Alt+3',
  [ShortcutAction.SwitchToContacts]: 'Shift+Alt+4',
  [ShortcutAction.JumpToActiveCall]: 'Shift+Alt+J',
  [ShortcutAction.AttendedTransfer]: 'Shift+Alt+T',
  [ShortcutAction.ReplyToLastConversation]: 'Shift+Alt+L',
  [ShortcutAction.MarkConversationRead]: 'Shift+Alt+U',
  [ShortcutAction.CallSelectedContact]: 'Shift+Alt+C',
  [ShortcutAction.VoicemailPlayPause]: 'Shift+Alt+V',
  [ShortcutAction.VoicemailSkipForward]: 'Shift+Alt+ArrowRight',
  [ShortcutAction.VoicemailSkipBack]: 'Shift+Alt+ArrowLeft',
  [ShortcutAction.VoicemailDelete]: 'Shift+Alt+X',
  [ShortcutAction.VoicemailCallBack]: 'Shift+Alt+B',
  [ShortcutAction.FocusSearch]: 'Shift+Alt+F',
};
